
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cafes-restaurants/[slug]",
      function () {
        return require("private-next-pages/cafes-restaurants/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cafes-restaurants/[slug]"])
      });
    }
  